import {
  createReducer, on
} from '@ngrx/store';
import { AuthUserEntity } from './../../../types/AuthUser';
import { AuthActions } from './action-typs';

export const authFeatureKey = 'auth';


export interface AuthState {
  authUser: AuthUserEntity|undefined
}

export const initialAuthState: AuthState = {
  authUser: {} as AuthUserEntity
}

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.login, (state, action) => {
    return {
      authUser: action.authUser
    };
  }),
  on(AuthActions.logout, (state, action) => {
    return {
      ...state,
      authUser: action.authUser,
    };
  })
);